import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@sunwebgroup/uds-ui/utils'
import styles from './WeatherGraphBar.module.css'

interface WeatherGraphBarProps {
  ratio: number
  className?: string
  children: ReactNode
}

export function WeatherGraphBar({ ratio, className, children }: WeatherGraphBarProps) {
  const graphBarStyle = { '--graph-bar-ratio': ratio } as CSSProperties

  return (
    <div className={cn(styles.root, className)} style={graphBarStyle}>
      {children}
    </div>
  )
}
